// Scripts available everywhere
import '../components/hs-header';
import '../components/hs-unfold';
import '../components/hs-focus-state';
import '../components/hs-malihu-scrollbar';
import '../components/hs-show-animation';
import '../components/hs-validation';
import '../components/hs-go-to';
import '../components/hs-svg-injector';
import '../components/hs-modal-window';
import '../components/hs-step-form';
import '../components/hs-selectpicker';
import '../../modules/dzsparallaxer/dzsparallaxer.dev';
import '../components/hs-slick-carousel';
import '../components/hs-scroll-nav';
import '../components/vendor/jquery-editable-select';
import '../components/vendor/cubeportfolio/js/jquery.cubeportfolio.min';
import '../components/hs-cubeportfolio';

import eModal from 'emodal';

// temp testing
import 'datatables.net';
import '../components/hs-datatables';
import '../components/hs-selectpicker';

export default {
  init() {

    //BIZ-1041 show mega menu when focus event
    $(document).on('ready', function(){
      
      $("#help-nav").on('focus', function(){
        $("#aboutDropdown").addClass('u-unfold--hidden');
        $("#aboutDropdown").css('visibility','hidden');
        $("#aboutDropdownInvoker").attr("aria-expanded","false");

        $("#contactDropdown").addClass('u-unfold--hidden');
        $("#contactDropdown").css('visibility','hidden');
        $("#aboutDropdownInvoker").attr("aria-expanded","false");
      });

      $("#contactDropdownInvoker").on('focus', function(){
        $("#aboutDropdown").addClass('u-unfold--hidden');
        $("#aboutDropdown").css('visibility','hidden');
        $("#aboutDropdown").removeClass('u-unfold--css-animation');
        $(this).attr("aria-expanded","true");
        $("#aboutDropdownInvoker").attr("aria-expanded","false");

        $(this).addClass('active');
        $("#contactDropdown").removeClass('u-unfold--hidden');
        $("#contactDropdown").addClass('u-unfold--css-animation');
        $("#contactDropdown").css('visibility','visible');
      });
      
      $("#aboutDropdownInvoker").on('focus', function(){
        $("#contactDropdown").addClass('u-unfold--hidden');
        $("#contactDropdown").css('visibility','hidden');
        $("#contactDropdown").removeClass('u-unfold--css-animation');
        $(this).attr("aria-expanded","true");
        $("#contactDropdownInvoker").attr("aria-expanded","false");


        $(this).addClass('active');
        $("#aboutDropdown").removeClass('u-unfold--hidden');
        $("#aboutDropdown").addClass('u-unfold--css-animation');
        $("#aboutDropdown").css('visibility','visible');
      });
      $(".focusdiv-menu").on('focus', function(){
          var id = $(this).attr('id');
          var focusevent = $(this).attr('focusevent');
            $(".organisationsMegaMenuForOrg").hide();
            $(".organisationsMegaMenuForIndiv").hide();
            $(".organisationsMegaMenuForRes").hide();
            $(".nav-item").removeClass("hs-mega-menu-opened");
          if(focusevent){
            $("."+id).show();
            $(this).parent().addClass("hs-mega-menu-opened");
          }
      });
    });

    // initialization of HSMegaMenu component
    $('.js-mega-menu').HSMegaMenu({
      event: 'hover',
      pageContainer: $('.container'),
      breakpoint: 767.98,
      hideTimeOut: 0
    });

    // initialization of cube portfolio
    $.HSCore.components.HSCubeportfolio.init('.cbp');

    // initialization of svg injector module
    $.HSCore.components.HSSVGIngector.init('.js-svg-injector');

    // initialization of autonomous popups
    $.HSCore.components.HSModalWindow.init('[data-modal-target]', '.js-modal-window', {
      autonomous: true
    });

    // initialization of fancybox
    $.HSCore.components.HSFancyBox.init('.js-fancybox');

    // initialization of sticky blocks
    $.HSCore.components.HSStickyBlock.init('.js-sticky-block');

    // initialization of header
    $.HSCore.components.HSHeader.init($('#header'));

    // initialization of unfold component
    $.HSCore.components.HSUnfold.init($('[data-unfold-target]'), {
      afterOpen: function () {
        $(this).find('input[type="search"]').focus();
      }
    });

    // initialization of malihu scrollbar
    $.HSCore.components.HSMalihuScrollBar.init($('.js-scrollbar'));

    // initialization of show animations
    $.HSCore.components.HSShowAnimation.init('.js-animation-link');

    // initialization of step form
    $.HSCore.components.HSStepForm.init('.js-step-form');

    // initialization of form validation
    var delay = 3000;
    $.HSCore.components.HSValidation.init('.js-validate', {
      // Currently not being used but leaving as an example
      setDefaults: {
        ignore: [],
        doNotHideMessage: true,
      },
      rules: {
        startDateCalendar: {
          required: true
        },
        postcode: {
          remote: {
            url: ajaxdta.ajaxurl,
            data: ({
              'action': "verify_australian_postcode",
              'nonce': ajaxdta._nonce,
              postcode: function() {
                return $( "#postcode" ).val();
              }
            }),
          }
        },
        'response_populations[]': {
          required: true
        }
      },
      errorPlacement: function (error, element) { // render error placement for each input type
        if (element.parents('.form-check').size() > 0) {
          error.appendTo(element.parents('.form-check').attr("data-error-container"));
        }
        if (element.parents('.choice').size() > 0) {
          error.appendTo(element.parents('.choice').attr("data-error-container"));
        } else {
          error.insertAfter(element); // for other inputs, just perform default behavior
        }
      },
      submitHandler: function (form) {

        $.ajax({
          url: $(form).attr('action'),
          type: $(form).attr('method'),
          data: $(form).serializeArray(),
          dataType: 'json',

          // Hide stuff and show dropDownNotice
          beforeSend: function () {

            if( !$(form).hasClass('js-form-no-feedback') ) {
              $("html, body").animate({scrollTop: 0}, 'slow');
              $('.dropDownNoticeClose').trigger('click');
            }


            $(form).closest('div.js-form-hide-before-send').fadeOut('slow');

          },

          // Set ajax_result message
          success: function (response) {

            if ( response.success ) {
              $('#infoFormAlert').find('.response-message').addClass('alert-success');
            }
            else {
              $('#infoFormAlert').find('.response-message').addClass('alert-danger');
              if( $(form).hasClass('js-form-show-errors') ) {
                $("html, body").animate({scrollTop: 0}, 'slow');
                $('.dropDownNoticeClose').trigger('click');
                $(form).addClass('error');
              }
            }
            $('#infoFormAlert').find('.response-message').html(response.data.message);

            if(response.data.location){
              if(response.data.replaceLocation){
                window.setTimeout(function(){window.location.replace(response.data.location)}, 1300);
              }
              else{
                window.setTimeout(function(){window.location.href=response.data.location}, 1300);
              }
            }
          },

          // For debugging ajax connection issues.
          error: function (jqXHR, textStatus, errorThrown) {
            $(form).addClass('fatal-error');
            $("html, body").animate({scrollTop: 0}, 'slow');
            $('#infoFormAlert').find('.response-message').addClass('alert-danger');
            $('#infoFormAlert').find('.response-message').html('Sorry an unexpected communication error was detected.<br/>Please try again or' +
              ' contact our support team if this continues.');
            if( $(form).hasClass('js-form-no-feedback') ) {
              $('.dropDownNoticeClose').trigger('click');
            }
          },

          // hide spinner and show ajax_result
          complete: function () {
            let displayFeedBack = false;

            if(
              (!$(form).hasClass('js-form-no-feedback')) ||
              ( ($(form).hasClass('error')) && ($(form).hasClass('js-form-show-errors')) )
            ){
              displayFeedBack = true;
            } else if( $(form).hasClass('fatal-error') ){
              displayFeedBack = true;
            }

            if( displayFeedBack ){
              $('#ajaxSpinner').hide();
              $('#infoFormAlert').fadeIn('slow');
              setTimeout(function () {
                $('.dropDownNoticeClose').trigger('click');
                return false;
              }, delay);

            }
          }
        });

        // Don't redirect
        return false;
      }
    });

    // initialization of slick carousel
    $.HSCore.components.HSSlickCarousel.init('.js-slick-carousel');

    // initialization of HSScrollNav component
    $.HSCore.components.HSScrollNav.init($('.js-scroll-nav'), {
      duration: 700
    });


    // initialization of go to
    $.HSCore.components.HSGoTo.init('.js-go-to');

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    // Temp testing - initialization of datatables
    $.HSCore.components.HSDatatables.init('.js-datatable-ttp', {
      dom: 'lBfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Export to CSV',
          className: 'btn btn-primary btn-sm mr-2',
          init: function(api, node, config) {
            $(node).removeClass('btn-secondary')
          },
        },
        {
          extend: 'excel',
          className: 'd-none'
        },
        {
          extend: 'pdf',
          className: 'd-none'
        },
      ],
    });

    // Redirect simple directions form
      $("#directions_simple").on('click', function() {
        location.href=document.getElementById("directions_select").value;
      });

      // This might just be needed on the TTP page
    $(".survey").on('click', function(){
      var url = $(this).data('modal-url');
      var title = $(this).data('modal-title');
      var options = {
        url: url,
        title: title,
        size: 'lg',
        buttons: [
          {text: 'Close', style: 'primary',   close: true }
        ],
      };
      eModal.iframe(options);
    });



    // initialise jquery editable select
    $.HSCore.components.JqueryEditableSelect.init('.js-editable-select');

    // initialise bootstrap select
    $.HSCore.components.HSSelectPicker.init('.js-select');

    // Select value in input text fields on click
    $(".js-validate input[type='text']").on("click", function () {
      $(this).trigger("select");
    });

    // Add jquery-validation method noemail to check if an email has been entered where its not needed.
    $.validator.addMethod("noemail", function (value, element) {
      return this.optional(element) || /(?:\s|^)(?![a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)\S+\b(?=\s|$)/ig.test(value);
    }, "An email is not valid here.");

      // Scroll to top for Facetwp pagination
      $(document).on('facetwp-refresh', function() {
        if ( FWP.soft_refresh == true ) {
          FWP.enable_scroll = true;
        } else {
          FWP.enable_scroll = false;
        }
      });
      $(document).on('facetwp-loaded', function() {
        if ( FWP.enable_scroll == true ) {
          $('html, body').animate({ scrollTop: 0 }, 500);
        }
      });    



    /* BIZ-798 START: check validation for dropdown and fix style */
    $(".js-select").on('change', function(){
      var requiredStatus = $(this).data('rule-required');
      if(requiredStatus){
        var selectName = $(this).attr('name'); // get the name of dropbox
        var selectIDs = $(this).attr('id'); // get the id of dropbox
        var selectValue = $(this).val(); // get the value of dropbox
        $("."+selectName+"-parentdiv").find(".dropdown-toggle").removeAttr('style'); // remove css
        // Check validation if value blank
        if(selectValue == ''){
          if( typeof selectIDs === "undefined"){
            var errDiv = selectName; // if id not found, error class with select Name
          }else{
            var errDiv = $(this).attr('id'); // if id exists, then error class with ID
          }
          var errClas = errDiv+"-error";
          $(this).parent().parent().addClass(selectName+"-parentdiv"); // add parent to parent class
          $("#"+errClas).appendTo($("."+selectName+"-parentdiv"));
          $("."+selectName+"-parentdiv").find(".dropdown-toggle").attr('style', 'border:1px solid rgba(222, 68, 55, 0.5)!important');
        }
      }
      
    });
    //when click on submit button.
    $(".profileValidation").on('click', function(){
      //BIZ-823 START: Adding the clicked variable to identify the click event
      $(this).data('clicked', true);
      $( ".js-select" ).each(function( index ) {
        // Passing this element
        $(this).trigger("change");
      });
      //BIZ-823 START: Adding the clicked variable to identify the click event
    });
     /* BIZ-798 END: check validation for dropdown and fix style */


     /* BIZ-1346 START, if course count one, then set position fix*/
     $(function() {
      if ($("body").hasClass("online-dementia-courses")) {
        var lastcount = $("body").find('.subcoursediv').last().attr('totalcount');
        if(lastcount == 1)
        {
          $(".manuallyupdate").addClass('pos-fixed');
        }else{
          $(".manuallyupdate").removeClass('pos-fixed');
        }
      }
     });
    
     $(document).on('click', '.facetwp-checkbox', function() {
      setTimeout(function() { 
          if ($("body").hasClass("online-dementia-courses")) {
          var lastcount = $("body").find('.subcoursediv').last().attr('totalcount');
          if(lastcount == 1)
          {
            $(".manuallyupdate").addClass('pos-fixed');
          }else{
            $(".manuallyupdate").removeClass('pos-fixed');
          }
        }
      }, 2000);
     });
      /* BIZ-1346 END, if course count one, then set position fix*/

     
     $(function(){
        $(".de_more_details").click(function(){
            var num = $(this).attr('num');
            $(this).hide();
            $(".read_more_decontent_"+num).removeClass('d-none');
            $(".de_div_less_"+num).removeClass('d-none');
            $(".read_more_decontent_"+num).fadeIn();
            $(".de_div_less_"+num).show();
        });

        $(".de_less_details").click(function(){
          var num = $(this).attr('num');
          $(this).hide();
          $(".read_more_decontent_"+num).addClass('d-none');
          $(".de_div_less_"+num).addClass('d-none');
          $(".read_more_decontent_"+num).fadeOut();
          $(".de_div_more_"+num).show();
      });

     }); 

     


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js